import axios from 'axios';

import api_url from './api_url';

export default class RBACService {
  constructor(base_url) {
    this.base_url = base_url || api_url;
  }

  headers(token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }

  async getRoles(token) {
    const response = await axios.get(`${this.base_url}/v1/rbac/roles`, this.headers(token));
    return response.data;
  }

  async getSettings(token) {
    const response = await axios.get(`${this.base_url}/v1/rbac/settings`, this.headers(token));
    return response.data;
  }

  async updateSettings(token, payload) {
    const response = await axios.put(`${this.base_url}/v1/rbac/settings`, payload, this.headers(token));
    return response.data;
  }

  async createRole(token, payload) {
    const response = await axios.post(`${this.base_url}/v1/rbac/roles`, payload, this.headers(token));
    return response.data;
  }

  async updateRole(token, id, payload) {
    const response = await axios.put(`${this.base_url}/v1/rbac/roles/${id}`, payload, this.headers(token));
    return response.data;
  }

  async deleteRole(token, id) {
    const response = await axios.delete(`${this.base_url}/v1/rbac/roles/${id}`, this.headers(token));
    return response.data;
  }

  async getPermissions(token) {
    const response = await axios.get(`${this.base_url}/v1/rbac/permissions`, this.headers(token));
    return response.data;
  }

  async createPermission(token, payload) {
    const response = await axios.post(`${this.base_url}/v1/rbac/permissions`, payload, this.headers(token));
    return response.data;
  }

  async updatePermission(token, id, payload) {
    const response = await axios.put(`${this.base_url}/v1/rbac/permissions/${id}`, payload, this.headers(token));
    return response.data;
  }

  async deletePermission(token, id) {
    const response = await axios.delete(`${this.base_url}/v1/rbac/permissions/${id}`, this.headers(token));
    return response.data;
  }

  async getRolePermissions(token, roleId) {
    const response = await axios.get(`${this.base_url}/v1/rbac/roles/${roleId}/permissions`, this.headers(token));
    return response.data;
  }

  async assignRolePermissions(token, roleId, permissionIDs) {
    const response = await axios.put(
      `${this.base_url}/v1/rbac/roles/${roleId}/permissions`,
      { permission_ids: permissionIDs },
      this.headers(token),
    );
    return response.data;
  }

  async getUsers(token) {
    const response = await axios.get(`${this.base_url}/v1/rbac/users`, this.headers(token));
    return response.data;
  }

  async assignUserRoles(token, userId, roleIDs) {
    const response = await axios.put(
      `${this.base_url}/v1/rbac/users/${userId}/roles`,
      { role_ids: roleIDs },
      this.headers(token),
    );
    return response.data;
  }

  async getRoleTags(token, roleId) {
    const response = await axios.get(`${this.base_url}/v1/rbac/roles/${roleId}/tags`, this.headers(token));
    return response.data;
  }

  async assignRoleTags(token, roleId, tagIDs) {
    const response = await axios.put(
      `${this.base_url}/v1/rbac/roles/${roleId}/tags`,
      { tag_ids: tagIDs },
      this.headers(token),
    );
    return response.data;
  }
}
